import * as devtoolsDetector from 'devtools-detector';

export default {
  install() {
    const getQuueryVariable = (val) => {
      const query = window.location.search.substring(1);
      const vars = query.split('&');
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (pair[0] == val) {
          return pair[1];
        }
      }
      return false;
    };
    devtoolsDetector.addListener((isOpen) => {
      if (isOpen) {
        window.location.replace('https://www.baidu.com');
      }
    });
    if (!getQuueryVariable('devTest') && process.env.NODE_ENV == 'production') {
      devtoolsDetector.launch();
    }
  },
};
